module.exports = __webpack_public_path__ + "img/icon-dogs.aefdb247.svg";